import AppRouterTemplate from './app-router-template';
import { getAppRoutesFromConfigs } from './get-app-routes-from-configs';
import { avonPatientRouteConfig } from './routes/avon-patient.routes';
import { callsPageRouteConfig } from './routes/calls-page.routes';
import { docketRouteConfig } from './routes/docket.routes';
import { guideListPageRouteConfig } from './routes/guide-list.routes';
import { loginPageRouteConfig } from './routes/login.routes';
import { memberListRouteConfig } from './routes/member-list.routes';
import { memberPageRouteConfig } from './routes/member-page.routes';
import { trainingAdminPageRouteConfig } from './routes/training-admin.routes';
import ErrorPage from './routes/StatusPages/ErrorPage';
import { adminDashboardRouteConfig } from './routes/admin-dashboard-routes';
import { hospitalizationRouteConfig } from './routes/hospitalization.routes';
import CareApp from '../care-app';
import { noAccessPageRouteConfig } from './routes/no-access.routes';

export { getMemberPageUrl } from './navigation-hooks';
export { useAppNavigation } from './useAppNavigation';

const childRoutes = getAppRoutesFromConfigs([
  docketRouteConfig,
  memberListRouteConfig,
  memberPageRouteConfig,
  callsPageRouteConfig,
  guideListPageRouteConfig,
  trainingAdminPageRouteConfig,
  loginPageRouteConfig,
  avonPatientRouteConfig,
  adminDashboardRouteConfig,
  hospitalizationRouteConfig,
  noAccessPageRouteConfig,
]);

export const routes = [
  {
    path: '/',
    element: <CareApp />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppRouterTemplate />,
        children: childRoutes,
        errorElement: <ErrorPage />,
      },
      {
        path: '*',
        element: <ErrorPage />,
      },
    ],
  },
];
